export default __webpack_public_path__ + "media/images/images/elements/01-98ba395ec046c86d19a4723759c7ffbc.png";